import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Toolbar from '@material-ui/core/Toolbar';
import Pagination from '@material-ui/lab/Pagination';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import { inject, observer } from 'mobx-react';
import { Framework } from '@flint/framework';

import Row from "./Row";

const tableHeadings = [
    "Name", "Status", "Email", "Admin"
]

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        padding: theme.spacing(4),
    },
    toolbar: {
        paddingLeft: theme.spacing(2.5),
        paddingRight: theme.spacing(2.5),
    },
    paper: {
        width: '100%',
    },
    title: {
        flex: '1 1 100%',
        fontFamily: "Merriweather",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "28px",
        lineHeight: "90px",
        color: "#222747",
    },
    tableHeading: {
        fontSize: "20px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "29px",
        color: "#000000",
    },
    searchForm: {
        width: "100%",
        padding: theme.spacing(2),
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
    },
    searchButton: {
        color: "#FFF",
        padding: "15px",
        fontSize: "18px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "20px",
        background: "#222747",
        borderRadius: "3px",
        textTransform: "unset",
        transition: "background 0.25s",
        border: "2px solid #222747",
        "&:hover": {
            background: "none",
            color: "#222747",
        },
        width: "100%",
    },
    searchInput: {
        width: "100%",
    },
    paginationRow: {
        padding: theme.spacing(2),
        display: "flex",
        justifyContent: "center",
    },
    gridItem: {
        margin: theme.spacing(1),
    }
}));
const handleAddAdmin = () => {
    Framework.redirect(`/add-admin`);
}
const UserTable = ({ UserListStore }) => {

    const classes = useStyles();
    const [rows, setRows] = React.useState([]);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [page, setPage] = React.useState(0);

    const rowsPerPage = 10;

    const searchSubscription = (e) => {
        e.preventDefault();
        const filteredRows = rows.filter(row => row.name.toLowerCase().includes(searchTerm.toLowerCase()));
        setRows(filteredRows);
        setPage(0);
    }


    const clearSearchFilter = () => {
        setSearchTerm("");
        setRows(UserListStore.users);
        setPage(0);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage - 1);
    };

    React.useEffect(() => {
        document.title = "User List Page";
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        UserListStore.fetch();
        setRows(UserListStore.users);
    }, []);

    return (
        <>
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <Grid container wrap="wrap" alignItems="center" justify="space-between">
                        <form className={classes.searchForm} onSubmit={searchSubscription}>
                            <Grid item xs={12} sm={6} md={7} className={classes.gridItem}><TextField id="search-term" label="Search" variant="outlined" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className={classes.searchInput} /></Grid>
                            <Grid item xs={12} sm={2} className={classes.gridItem}><Button type="submit" variant="contained" className={classes.searchButton}>Search</Button></Grid>
                            <Grid item xs={12} sm={2} className={classes.gridItem}><Button variant="contained" onClick={clearSearchFilter} className={classes.searchButton}>Clear Search</Button></Grid>
                        </form>
                    </Grid>
                    <Toolbar className={classes.toolbar}>
                        <Typography className={classes.title} variant="h1" id="tableTitle" component="div">
                            User Table
                    </Typography>
                        <Tooltip title="Add Administrator">
                            <IconButton onClick={handleAddAdmin}>
                                <LibraryAddIcon className={classes.addIcon} />
                            </IconButton>
                        </Tooltip>
                    </Toolbar>
                    <TableContainer>
                        <Table aria-label="collapsible table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ width: "10px" }} />
                                    {tableHeadings.map(tableHeading => <TableCell align={"center"} className={classes.tableHeading} key={tableHeading}>{tableHeading}</TableCell>)}
                                    <TableCell />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row) => (
                                        <Row key={row.id} row={row} />
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {rows.length > rowsPerPage && <Pagination count={Math.ceil(rows.length / rowsPerPage)} onChange={handleChangePage} shape="rounded" className={classes.paginationRow} />}
                </Paper>
            </div>
        </>
    );
}

export default inject('UserListStore')(observer(UserTable));